import { selectQuoteBuilder } from '@ui/features/quote-builder/state/selectors/quote-builder';
import { RootState } from '@ui/store';

export const selectCurrentDialog = (state: RootState) =>
  selectQuoteBuilder(state).dialog;
